import { reloadedThemes } from '@openbank/ziniaweb-ui-components';

const THEME_PROVIDER_PROPS = {
  alternativeThemeName: reloadedThemes.cobranded_light_alternative,
  themeName: reloadedThemes.cobranded_light_regular,
  theme: reloadedThemes.cobranded_light_regular,
};

export { THEME_PROVIDER_PROPS };
